import Vue from 'vue'
import VueRouter from 'vue-router'
import userManager from "@/assets/plugins/mps-common/user/user-manager";
import WelcomeRouter from "@/router/WelcomeRouter";
import MainRouter from "@/router/MainRouter";
import ErrorRouter from "@/router/ErrorRouter";
import {resolveAuthenticatedHomePath} from "@/router/resolve-authenticated-home";

Vue.use(VueRouter)

const routes = [
    /**
     *  루트 분기 라우터입니다.
     *  "/"로 접근할시 로그인 여부와 권한에 따라 적절한 페이지로 라우팅합니다.
     */
    {
        name: 'RootDivider', path: '/', meta: {
            divider: true,
            history: true,
            mapping: [
                /** 로그인하면 보유 권한에 맞는 첫 화면으로 이동 (사이드 메뉴 순) */
                {requiresAuth: true, resolveHome: true},
                /** 로그인 전 웰컴화면으로 이동 */
                {to: "/welcome"},
            ],
        },
    },

    /**
     * 로그인 후 적용되는 라우터입니다.
     */
    {
        path: '/',
        props: false,
        component: () => import(/* webpackChunkName: "main" */ '../views/main/Main'),
        children: MainRouter,
        meta: {
            requiresAuth: true,
        },
    },

    /**
     * 로그인 전 적용되는 라우터입니다.
     */
    {
        path: '/welcome',
        props: false,
        name: 'Welcome',
        component: () => import(/* webpackChunkName: "welcome" */ '../views/welcome/Welcome'),
        children: WelcomeRouter,
        meta: {
            requiresAuth: false,
        },
    },

    /**
     * 에러 페이지 라우터입니다.
     */
    {
        path: "/",
        props: false,
        component: () => import(/* webpackChunkName: "welcome" */ '../views/errors/ErrorMain'),
        children: ErrorRouter,
        meta: {
            requiresAuth: false,
        },
    },

    /** Redirect to 404 Page Not Found */
    {
        path: "*",
        redirect: "/404"
    },
    /** 404 Page Not Found */
    {
        path: "/404",
        name: "PageNotFound",
        component:  () => import('../views/errors/PageNotFound'),
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    /** 분기 레코드 */
    if (to.meta.divider) {
        const redirectData = to.meta.mapping.find(routeData => {
            if (routeData.requiresAuth) { // 인증이 필요한 라우터 입니다.
                if (!userManager.validate) return false; // 로그인하지 않았다면 false 반환
                
                if (!!routeData.permission) {
                    return userManager.hasPermission(routeData.permission);
                } else {
                    return true;
                }
            } else {
                return true;
            }
        });

        if (redirectData) {
            const redirectTo = redirectData.resolveHome
                ? resolveAuthenticatedHomePath(router)
                : redirectData.to;

            // 해당되는 라우터로 이동
            if (to.meta.history) {
                return window.location.href = redirectTo;
            } else {
                return next({name: redirectTo, replace: false /* 분기 라우터의 경우 히스토리를 남깁니다. */});
            }
        }

        // 분기 라우트의 로직이 정상이라면 이 페이지는 출력되지 않습니다!
        return next({name: "NoMachedRoute"});
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        // 특정 화면으로 이동시 유저가 필요한 권한을 모두 가졌는지 체크한다.
        if (userManager.validate && (!to.meta.permission || userManager.hasPermission(to.meta.permission))) {
            return next();
        }

        // 그 외는 404페이지를 띄어 페이지를 보여주지 않습니다.
        return next({name: 'PageNotFound'});
    }

    // 인증이 필요없는 라우트입니다. 진행합니다.
    return next();
});

export default router
